// EASILY UPDATABLE PROJECT DATA
// Replace `image` URLs with your own designs. Keep structure intact.

// ============ CREATIVE GALLERY (images-only masonry wall) ============
// Just paste new image URLs here to update the gallery.
// `span` = which rows the tile spans on desktop → creates the random masonry feel.
export const GALLERY = [
  {
    id: "g1",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/frvpu10x_Artboard%204%20copy.jpg",
  },
  {
    id: "g2",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/ifgju6dl_%D8%A8%D9%88%D8%B3%D8%AA%20%D9%81%D9%88%D8%A7%D9%83%D9%87.jpg",
  },
  {
    id: "g3",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/ezh0j1rg_%D8%A8%D9%8A%D8%A8%D9%8A%20%D8%AC%D9%88%D9%8A%20%D8%A8%D9%88%D8%B3%D8%AA.jpg",
  },
  {
    id: "g4",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/eznjf7ql_%D8%A8%D8%B1%D8%A8%D9%8A%D9%83%D8%A7%D9%86%20%D8%B7%D8%A7%D9%82%D9%87%20%D8%B3%D8%AA%D9%88%D8%B1%D9%8A_.jpg",
  },
  {
    id: "g5",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/fusjqcov_%D8%A7%D8%A8%D8%AA%D8%B3%D8%A7%D9%85%D8%A9%20%D8%B7%D9%81%D9%84%D9%83.jpg",
  },
  {
    id: "g6",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/6ufxbf3m_Artboard%201%20copy%209.jpg",
  },
  {
    id: "g7",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/2c2r9pi2_Artboard%201%20copy%2010.jpg11.jpg",
  },
  {
    id: "g8",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/1nagupbs_4.jpg",
  },
  {
    id: "g9",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/119rsilg_banner%20%20%D9%83%D8%B1%D8%B3%D8%AA%D8%A7%D8%B3%20%D8%A8%D9%86%D8%B1%20%D9%84%D8%B9%D8%A8%D9%871_.jpg",
  },
  {
    id: "g10",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/w458y3oj_isadora.webp",
  },
  {
    id: "g11",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/4t4rcb03_nabla%201%20post_.jpg",
  },
  {
    id: "g12",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/nescib0a_9.jpg",
  },
  {
    id: "g13",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/8t6cd2jg_11.jpg",
  },
];

// ============ SELECTED BRAND PROJECTS ============
// Each project card needs: brand, title, category, description, image, link (optional).
// EASY UPDATE: just paste new URLs into the `image` field or add new entries.
export const PROJECTS = [
  {
    id: 1,
    brand: "NWAH · Essence of You",
    title: "Perfume Social Grid",
    category: "Product Design",
    year: "2025",
    description:
      "شبكة سوشيال ميديا كاملة لبراند عطور NWAH — تصوير منتج فاخر ومنشورات على ستايل انستغرام.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/8zgo3k1r_%D8%B9%D8%B7%D9%88%D8%B1%20%D9%86%D9%88%D8%A7%D9%871.jpg",
    link: "#contact",
  },
  {
    id: 2,
    brand: "Shant",
    title: "Shant Pure Water",
    category: "Product Design",
    year: "2025",
    description: "إعلان بصري لمياه شانت — نقاء يرافقك في كل لحظة.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/9zs419id_%D8%B3%D8%AA%D9%88%D8%B1%D9%8A%20%D9%85%D9%8A%D8%A7%D9%87%20%D8%B4%D8%A7%D9%86%D8%AA.jpg",
    link: "#contact",
  },
  {
    id: 3,
    brand: "Bakery Ad",
    title: "كل قضمة — Pastry Campaign",
    category: "Product Design",
    year: "2025",
    description:
      "حملة إعلانية لمنتج مخبوزات — كل قضمة تحمل لذّتها الخاصة.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/wxyew3xk_Artboard%201%20copy%204.jpg",
    link: "#contact",
  },
  {
    id: 4,
    brand: "Donut Café",
    title: "مستحيل! طعم يجنن",
    category: "Product Design",
    year: "2025",
    description:
      "بوستر إعلان لمقهى دوناتس — تصميم مفعم بالطاقة والحيوية.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/e8wpk308_Artboard%201%20copy%202.jpg",
    link: "#contact",
  },
  {
    id: 5,
    brand: "Matcha House",
    title: "Iced Matcha Ad",
    category: "Product Design",
    year: "2025",
    description: "إعلان مشروب ماتشا — بصريات نظيفة وألوان قوية.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/ri3fokvp_Artboard%201%20copy%203.jpg",
    link: "#contact",
  },
  {
    id: 6,
    brand: "Bar-B-Kan",
    title: "Energy Drink Campaign",
    category: "Product Design",
    year: "2024",
    description:
      "حملة سوشيال لمشروب طاقة بربيكان — تصوير رياضي وتايبوغرافي قوي.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/eznjf7ql_%D8%A8%D8%B1%D8%A8%D9%8A%D9%83%D8%A7%D9%86%20%D8%B7%D8%A7%D9%82%D9%87%20%D8%B3%D8%AA%D9%88%D8%B1%D9%8A_.jpg",
    link: "#contact",
  },
  {
    id: 8,
    brand: "BabyJoy · Shant",
    title: "Choose Comfort for Your Baby",
    category: "Product Design",
    year: "2024",
    description: "بوست منتج لحفاضات BabyJoy — إختاري راحة طفلك.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/ezh0j1rg_%D8%A8%D9%8A%D8%A8%D9%8A%20%D8%AC%D9%88%D9%8A%20%D8%A8%D9%88%D8%B3%D8%AA.jpg",
    link: "#contact",
  },
  {
    id: 9,
    brand: "Shant App",
    title: "Fresh Fruits Delivery",
    category: "Product Design",
    year: "2024",
    description: "إعلان تطبيق شانت — توصيل فواكه طازجة إلى بابك.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/ifgju6dl_%D8%A8%D9%88%D8%B3%D8%AA%20%D9%81%D9%88%D8%A7%D9%83%D9%87.jpg",
    link: "#contact",
  },
  {
    id: 10,
    brand: "Kérastase Paris",
    title: "Iraq Team Win Banner",
    category: "Product Design",
    year: "2025",
    description: "بنر ترويجي لكيراستاس بمناسبة فوز المنتخب العراقي — خصم 15%.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/119rsilg_banner%20%20%D9%83%D8%B1%D8%B3%D8%AA%D8%A7%D8%B3%20%D8%A8%D9%86%D8%B1%20%D9%84%D8%B9%D8%A8%D9%871_.jpg",
    link: "#contact",
  },
  {
    id: 11,
    brand: "Isadora",
    title: "Holiday Gift Box",
    category: "Product Design",
    year: "2024",
    description: "بوستر ترويجي لصندوق هدايا عيد الميلاد من ايزادورا.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/w458y3oj_isadora.webp",
    link: "#contact",
  },
  {
    id: 12,
    brand: "Nabla",
    title: "لمسة جمال طبيعية",
    category: "Product Design",
    year: "2024",
    description: "بوست منتجات مكياج نبلة — خصم 25% مع تحميل التطبيق.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/4t4rcb03_nabla%201%20post_.jpg",
    link: "#contact",
  },
  {
    id: 13,
    brand: "Karez Lebanon",
    title: "عشق البستاشيو الحقيقي",
    category: "Product Design",
    year: "2024",
    description: "بوستر منتج حلويات — كيك البستاشيو من كرز لبنان.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/8t6cd2jg_11.jpg",
    link: "#contact",
  },
  {
    id: 14,
    brand: "Karez Lebanon",
    title: "مذاق استثنائي بكل لقمة",
    category: "Product Design",
    year: "2024",
    description: "بوستر إبداعي لحلويات كرز لبنان.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/nescib0a_9.jpg",
    link: "#contact",
  },
  {
    id: 15,
    brand: "Mr.Protein",
    title: "Supplements Campaign — Female Athletes",
    category: "Campaign Design",
    year: "2025",
    description:
      "حملة سوشيال ميديا لمكملات غذائية — تصاميم بوسترات رياضية بأسلوب سينمائي وطاقة عالية.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/urk8aiix_Artboard%203%20copy%203.jpg",
    link: "#contact",
  },
  {
    id: 16,
    brand: "Mr.Protein",
    title: "Beast Mode Campaign",
    category: "Campaign Design",
    year: "2025",
    description:
      "حملة إعلانية لمكملات البروتين — أسلوب سينمائي وشخصيات مركّبة بالذكاء الاصطناعي.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/ey7oefwu_Artboard%203%20copy%202.jpg",
    link: "#contact",
  },
  {
    id: 17,
    brand: "Mr.Protein",
    title: "PRIME Protein Series",
    category: "Campaign Design",
    year: "2025",
    description:
      "سلسلة سوشيال ميديا لمنتج PRIME Protein — بورتريه رياضي وتايبوغرافي عربي جريء.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/8nhwvkxt_Artboard%203%20copy%204.jpg",
    link: "#contact",
  },
  {
    id: 18,
    brand: "Never Crumble",
    title: "Never Crumble — Cookie Brand",
    category: "Campaign Design",
    year: "2025",
    description:
      "براند كوكيز — تصاميم سوشيال ميديا: بوكس فاخر وكوكيز طائرة بأسلوب سينمائي.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/i56ua4ws_Artboard%203%20copy.jpg",
    link: "#contact",
  },
  {
    id: 19,
    brand: "Never Crumble",
    title: "Never Crumble — Boxes Series",
    category: "Campaign Design",
    year: "2025",
    description:
      "سلسلة بوسترات لبراند Never Crumble بأسلوب سينمائي وحيوي.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/mkt0asix_Artboard%203%20copy%202%402x.webp",
    link: "#contact",
  },
  {
    id: 20,
    brand: "Never Crumble",
    title: "Never Crumble — Kids Campaign",
    category: "Campaign Design",
    year: "2025",
    description:
      "حملة سوشيال لبراند كوكيز — أطفال مع منتج بأجواء دافئة وحيوية.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/tszx2p6z_Artboard%203%20copy%203.jpg",
    link: "#contact",
  },
  {
    id: 21,
    brand: "Never Crumble",
    title: "Never Crumble — Teddy Series",
    category: "Campaign Design",
    year: "2025",
    description:
      "سلسلة حملة عاطفية لبراند Never Crumble مع لمسات دافئة ومنتج مركزي.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/pfvqm4ii_Artboard%203%20copy%204%402x.webp",
    link: "#contact",
  },
  {
    id: 22,
    brand: "Never Crumble",
    title: "Never Crumble — Family Campaign",
    category: "Campaign Design",
    year: "2025",
    description:
      "حملة عائلية لبراند كوكيز بأسلوب سينمائي وألوان دافئة.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/bnuv25ud_Artboard%203%20copy%204.jpg",
    link: "#contact",
  },
  {
    id: 23,
    brand: "Dowakum",
    title: "Dowakum Medical — Instagram Grid",
    category: "Campaign Design",
    year: "2025",
    description:
      "شبكة انستغرام كاملة لبراند Dowakum الطبي والتجميلي — Replengent, REVS PN Filler, Otesaly.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/xwybzsi3_%D8%AF%D9%88%D8%A7%D9%83%D9%85%201.jpg",
    link: "#contact",
  },
  {
    id: 24,
    brand: "NWAH",
    title: "NWAH — Essence of You",
    category: "Campaign Design",
    year: "2025",
    description:
      "حملة سوشيال ميديا كاملة لعطور NWAH — أجواء فاخرة وتايبوغرافي عربي أنيق.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/lccnm5ft_%D8%B9%D8%B7%D9%88%D8%B1%20%D9%86%D9%88%D8%A7%D9%871.jpg",
    link: "#contact",
  },
  {
    id: 25,
    brand: "Lavender × SVR",
    title: "Lavender — SVR Skincare",
    category: "Campaign Design",
    year: "2025",
    description:
      "حملة انستغرام لبراند Lavender بمنتجات SVR للعناية بالبشرة — بألوان بنفسجية درامية.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/0q3cb40z_%D9%84%D8%A7%D9%81%D9%86%D8%AF%D8%B1%202.jpg",
    link: "#contact",
  },
  {
    id: 26,
    brand: "Lavender × Gissah",
    title: "Lavender — Gissah Perfumes",
    category: "Campaign Design",
    year: "2025",
    description:
      "حملة انستغرام لبراند Lavender مع عطور Gissah — تصوير منتج فاخر ومنشورات سينمائية.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/j6arfkhd_%D9%84%D8%A7%D9%81%D9%86%D8%AF%D8%B1%204.jpg",
    link: "#contact",
  },
  {
    id: 27,
    brand: "Al-Muhra Clinic",
    title: "Al-Muhra Clinic — Dental Grid",
    category: "Campaign Design",
    year: "2025",
    description:
      "شبكة انستغرام لعيادة المهرة لطب وتجميل الأسنان — أنظمة أقساط، عروض، ومحتوى موسمي.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/t1p04yx9_%D8%A7%D9%84%D9%85%D9%87%D8%B1%D9%87%201.jpg",
    link: "#contact",
  },
  {
    id: 28,
    brand: "Red Car · Erbil",
    title: "Nissan Patrol Y61 — Desert",
    category: "Car Design",
    year: "2025",
    description: "إعلان سينمائي لسيارة نيسان باترول — نيسان باترول لكل الظروف.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/722id7qf_Artboard%204%20copy%204.jpg",
    link: "#contact",
  },
  {
    id: 29,
    brand: "Red Car · Erbil",
    title: "Nissan Patrol Y61 — Jungle Beast",
    category: "Car Design",
    year: "2025",
    description: "إعلان لمعرض Red Car — وحش الغابة، سيارة جبارة بأجواء استوائية.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/tfnzqlin_Artboard%204%20copy%203.jpg",
    link: "#contact",
  },
  {
    id: 30,
    brand: "Red Car · Erbil",
    title: "Nissan Patrol Y61 — Mountain",
    category: "Car Design",
    year: "2025",
    description: "إعلان لمعرض Red Car — قوة بلا حدود، سيارة على قمة الجبل.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/olfj9185_Artboard%204%20copy%202.jpg",
    link: "#contact",
  },
  {
    id: 31,
    brand: "Red Car · Erbil",
    title: "Nissan Patrol Y61 — Off-Road",
    category: "Car Design",
    year: "2025",
    description: "إعلان لمعرض Red Car — جاهزة لأي تضاريس، سيارة تخترق الطين والوحل.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/0z6upv0x_Artboard%204%20copy.jpg",
    link: "#contact",
  },
  {
    id: 32,
    brand: "Pepsi",
    title: "Pepsi Ice Slide",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح براند Pepsi — تصميم ديناميكي بأجواء رياضية وشبابية.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/z64f1h74_%D8%A8%D9%8A%D8%A8%D8%B3%D9%8A%20%D8%B3%D9%84%D8%A7%D9%8A%D8%AF.webp",
    link: "#contact",
  },
  {
    id: 33,
    brand: "Rifal",
    title: "Rifal Summer Slide",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح براند ريفال للعصائر — أجواء صيفية على البحر.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/kyzb2dhd_%D8%B1%D9%8A%D9%81%D8%A7%D9%84%20%D8%B3%D9%84%D8%A7%D9%8A%D8%AF.webp",
    link: "#contact",
  },
  {
    id: 34,
    brand: "Patreek",
    title: "Penguin Foods — Walnut Slide",
    category: "App Slides",
    year: "2025",
    description: "سلايد إعلاني لجوز باتريك من شركة البطريق للمواد الغذائية.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/4kdw5dxw_%D8%A7%D9%84%D8%A8%D8%B7%D8%B1%D9%8A%D9%82%20%D8%B3%D9%84%D8%A7%D9%8A%D8%AF.webp",
    link: "#contact",
  },
  {
    id: 35,
    brand: "American Garden",
    title: "American Garden Slide",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح براند American Garden — التفاصيل الصغيرة تصنع ألذّ فرق.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/ue7rqf3s_%D8%A7%D9%85%D8%B1%D9%8A%D9%83%D8%A7%D9%86%20%D8%AC%D8%A7%D8%B1%D8%AF%D9%86%201%20%D8%B3%D9%84%D8%A7%D9%8A%D8%AF.webp",
    link: "#contact",
  },
  {
    id: 36,
    brand: "Lavender × Huda Beauty",
    title: "Huda Beauty — Valentine Slide",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح Lavender × Huda Beauty بمناسبة عيد الحب — إشراقة تدوم طوال اليوم.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/6tsnizjr_%D9%87%D8%AF%D9%89%20%D8%A8%D9%8A%D9%88%D8%AA%D9%8A%20%D9%81%D9%84%D9%86%D8%AA%D8%A7%D9%8A%D9%86.jpg",
    link: "#contact",
  },
  {
    id: 37,
    brand: "Pepsi × Iraq",
    title: "Pepsi — FIFA World Cup 2026",
    category: "App Slides",
    year: "2026",
    description: "سلايد لصالح Pepsi بمناسبة كأس العالم — خليك متعطش للفوز مع المنتخب العراقي.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/kdxic1f7_%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%20%D8%A8%D9%8A%D8%A8%D8%B3%D9%8A%202.webp",
    link: "#contact",
  },
  {
    id: 38,
    brand: "Lay's",
    title: "Lay's — Yogurt & Herbs",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح Lay's — نكهة جديدة باللبن والأعشاب بشكل جديد.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/8s0p98tc_%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%20%D9%84%D9%8A%D8%B2%203.webp",
    link: "#contact",
  },
  {
    id: 39,
    brand: "Shant",
    title: "Shant — Fresh Fruits Stand",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح تطبيق شانت — انتعش بفواكه طازجة تخفف حرارة الصيف.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/z4dtfl5x_%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%20%D8%A7%D9%84%D8%AE%D8%B6%D8%B1%D9%88%D8%A7%D8%AA%202_.jpg",
    link: "#contact",
  },
  {
    id: 40,
    brand: "Shant",
    title: "Shant — Delivery Hours",
    category: "App Slides",
    year: "2025",
    description: "سلايد أوقات تطبيق شانت — من الساعة 8 صباحاً إلى الساعة 12 ليلاً.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/e67rf7b6_%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%20%D8%A7%D9%88%D9%82%D8%A7%D8%AA%20%D8%A7%D9%84%D8%AA%D8%B7%D8%A8%D9%8A%D9%82%201.jpg",
    link: "#contact",
  },
  {
    id: 41,
    brand: "Evolac Plus",
    title: "Evolac — Growing Up Formula",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح إيفولاك بلس — تركيبة متطورة تدعم نمو طفلك.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/jizxcint_%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%20%D8%A7%D9%8A%D9%81%D9%88%D9%84%D8%A7%D9%83%203.webp",
    link: "#contact",
  },
  {
    id: 42,
    brand: "Baby Life",
    title: "Baby Life — Comfort & Protection",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح Baby Life — الراحة والحماية لبداية صحية وآمنة.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/pi601hmy_%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%20%D8%A8%D9%8A%D8%A8%D9%8A%20%D9%84%D8%A7%D9%8A%D9%81%203.webp",
    link: "#contact",
  },
  {
    id: 43,
    brand: "Al Malwiya × Mersin × Awafi",
    title: "Spices Trio",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح ثلاثية البهارات — نكهة غنية بكل رشّة.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/4q3cbkb7_%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%20%D8%B1%D9%82%D9%85%202%D8%A8%D9%87%D8%A7%D8%B1%D8%A7%D8%AA_.jpg",
    link: "#contact",
  },
  {
    id: 44,
    brand: "Sandra",
    title: "Sandra Sorbetto — Strawberry & Vanilla",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح Sandra Sorbetto — انتعاش لا يقاوم بنكهة الفراولة والفانيلا.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/oqycsfoc_%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%D8%A7%D9%8A%D8%B3%20%D9%83%D8%B1%D9%8A%D9%85%202_.webp",
    link: "#contact",
  },
  {
    id: 45,
    brand: "Teemo",
    title: "Teemo — All Day Comfort",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح تيمو للحفاضات — مصممة لراحة طفلك طوال اليوم.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/x5lt8mab_%D8%AD%D9%81%D8%A7%D8%B8%D8%A7%D8%AA%20%D8%AA%D9%8A%D9%85%D9%88%20%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%203.jpg",
    link: "#contact",
  },
  {
    id: 46,
    brand: "Shant",
    title: "Shant — Farm to Door",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح تطبيق شانت — من المزرعة لباب بيتك، اطلب وخلي الباقي علينا.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/x6dg906b_%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%20%D8%A7%D9%84%D8%AE%D8%B6%D8%B1%D9%88%D8%A7%D8%AA%204_.webp",
    link: "#contact",
  },
  {
    id: 47,
    brand: "Netos",
    title: "Netos Energy Drink",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح مشروب الطاقة نيتوس — وياك لأخر اليوم.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/yeh0s007_%D9%86%D9%8A%D8%AA%D9%88%D8%B3%20%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%203_.webp",
    link: "#contact",
  },
  {
    id: 48,
    brand: "Santa Bremor",
    title: "Santa Bremor — Sea Treasures",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح Santa Bremor — سمك وكنوز بحرية بأجواء صيفية.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/7stmowr3_%D8%A7%D8%B3%D9%85%D8%A7%D9%83%20%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%202.jpg",
    link: "#contact",
  },
  {
    id: 49,
    brand: "Lavender × Nabla",
    title: "Nabla — Valentine Slide",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح Lavender × Nabla بمناسبة عيد الحب — ثقة، نعومة، ولمعة تخطف.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/qt4gy3x3_%D9%86%D8%A8%D9%84%D9%87%20%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%20%D9%81%D9%84%D9%86%D8%AA%D8%A7%D9%8A%D9%86.jpg",
    link: "#contact",
  },
  {
    id: 50,
    brand: "XLASH",
    title: "XLASH — Eyelash Serum",
    category: "App Slides",
    year: "2025",
    description: "سلايد لصالح XLASH لسيروم الرموش — تصميم مينيمال بأجواء رياضية بنفسجية.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/1tztsf87_ChatGPT%20Image%20May%2011%2C%202026%2C%2003_58_48%20PM.png",
    link: "#contact",
  },
];

// ============ FEATURED PROJECTS (vertical stacked) ============
export const FEATURED = [
  {
    id: "f1",
    title: "Lavender Store Slide",
    accent: "سلايد منتجات بيت الصابون",
    description:
      "سلايد لصالح تطبيق لافندر تظهر بها منتجات بيت الصابون.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/4walzc7t_ChatGPT%20Image%20May%2011%2C%202026%2C%2003_43_56%20PM.png",
  },
  {
    id: "f2",
    title: "Shant App",
    accent: "سلايد تطبيق شانت",
    description:
      "سلايد لصالح تطبيق شانت يجسد الفواكه الموجودة داخل التطبيق بتصميم حيوي وجذاب للمشاهد.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/gckws3cy_%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%202%20%20%D8%A7%D9%84%D9%81%D9%88%D8%A7%D9%83%D9%87.webp",
  },
  {
    id: "f3",
    title: "",
    accent: "منتج لصالح شركة الفاخر",
    description:
      "تصميم سلايد لصالح شركة الفاخر.",
    image:
      "https://customer-assets.emergentagent.com/job_basit-loay-design/artifacts/41r1jl5n_%D8%B3%D9%84%D8%A7%D9%8A%D8%AF%204%20%D8%A7%D9%84%D9%81%D8%A7%D8%AE%D8%B1_.webp",
  },
];

// ============ TESTIMONIALS (Arabic RTL) ============
export const TESTIMONIALS = [
  {
    id: "t1",
    name: "سارة الهاشمي",
    role: "صاحبة مشروع",
    text: "ساعدني باسط على تحويل أفكاري إلى هوية بصرية احترافية للشركة.",
  },
  {
    id: "t2",
    name: "محمد كريم",
    role: "طالب",
    text: "تصاميم المنتجات والإعلانات بالذكاء الاصطناعي صارت جزءاً أساسياً من هويتنا التسويقية. جودة العمل جانت أعلى من توقعاتنا.",
  },
  {
    id: "t3",
    name: "لينا يوسف",
    role: "متدربة",
    text: "بدأت الدورة من الصفر، واليوم صار عندي بورتفوليو احترافي وأكدر أنفذ مشاريع حقيقية للعملاء.",
  },
  {
    id: "t4",
    name: "أحمد حسين",
    role: "متدرب",
    text: "الأسلوب العملي والتطبيقات الواقعية داخل الدورة ساعدتني على تطوير مستواي بشكل أسرع مما توقعت.",
  },
];

export const CATEGORIES = [
  "Product Design",
  "Campaign Design",
  "Car Design",
  "App Slides",
];
